<template>
	<div id="app">
		<div class="container">
			<keep-alive v-if="$route.meta.keepAlive"><router-view></router-view></keep-alive>
			<router-view v-else></router-view>
		</div>
		<!-- <img src="./assets/logo.png">
    <div>
      <p>
        If Element is successfully added to this project, you'll see an
        <code v-text="'<el-button>'"></code>
        below
      </p>
      <el-button>el-button</el-button>
    </div>
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
	</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
	name: 'app'
	// components: {
	//   HelloWorld
	// }
};
</script>

<style lang="scss">
@import 'common/weida.scss';
// #app {
// 	font-family: 'Avenir', Helvetica, Arial, sans-serif;
// 	-webkit-font-smoothing: antialiased;
// 	-moz-osx-font-smoothing: grayscale;
// 	text-align: center;
// 	color: #2c3e50;
// 	margin-top: 60px;
// }
</style>
